export default {
    data() {
        return {
            pasiveColors: [
                '#999B9C',
                '#AEB0B1',
                '#C4C4C6',
                '#D7D8DA',
                '#EAEAED'
            ],

            activeColors: [
                '#95EED2',
                '#00D3A9',
                '#f7fd21',
                '#FFAE71',
                '#FF4F5C'
            ]
        }
    }
};